// store/modules/auth.js

import {
	userApi,
	storeApi
} from '../../api'; // 引入 api.js 中的 login 方法
import {
	loadRemembered,
	saveRemembered
} from '../../utils/remember';

const remembered = loadRemembered();
const MISSING_STORE_MSG_PATTERN = /(未创建|未完善|不存在).*(商家|店铺)|请先.*(创建|完善).*(商家|店铺)/;

const isMissingStoreInfo = (response) => {
	if (!response) {
		return false;
	}
	const success = response.code === 0 || response.code === 200;
	if (success) {
		return !response.data || response.data.id === null || response.data.id === undefined || response.data.id === '';
	}
	const msg = String(response.msg || '');
	return MISSING_STORE_MSG_PATTERN.test(msg);
};

const state = {
	isAuthenticated: false,
	user: null,
	username: remembered.username || '',
	storeId: null
};

const mutations = {
	SET_USERNAME(state, username) {
		state.username = username || '';
	},
	SET_AUTH(state, user) {
		state.isAuthenticated = true;
		state.user = user;
	},
	SET_STORE_ID(state, storeId) {
		state.storeId = storeId;
	},
	LOGOUT(state) {
		state.isAuthenticated = false;
		state.user = null;
		state.username = loadRemembered().username || '';
		state.storeId = null;
	},
};

const actions = {
	async login({
		commit,
		dispatch
	}, {
		username,
		password,
		checked
	}) {
		try {
			const response = await userApi.login({
				username,
				password
			});
			if (response.code !== 0 && response.code !== 200) {
				throw new Error(response.msg || 'Login failed');
			}
			commit('SET_USERNAME', username);
			saveRemembered(username, password, checked);
			commit('SET_AUTH', response.data);
			commit('SET_STORE_ID', null);
			await dispatch('ensureStoreId');
			return response;
		} catch (error) {
			commit('LOGOUT');
			throw error instanceof Error ? error : new Error((error && error.message) || 'Login failed');
		}
	},
	async ensureStoreId({
		state,
		commit
	}) {
		if (state.storeId !== null && state.storeId !== undefined && state.storeId !== '') {
			return state.storeId;
		}
		const userId = state.user && state.user.userId;
		if (!userId) {
			throw new Error('缺少用户信息，无法获取店铺ID');
		}
		const response = await storeApi.getStoreInfoDetail({
			id: userId
		});
		if (response && (response.code === 0 || response.code === 200) && response.data && response.data.id !== null && response.data.id !== undefined && response.data.id !== '') {
			commit('SET_STORE_ID', response.data.id);
			return response.data.id;
		}
		if (isMissingStoreInfo(response)) {
			commit('SET_STORE_ID', null);
			return null;
		}
		throw new Error((response && response.msg) || '获取店铺ID失败');
	},
	logout({
		commit
	}) {
		commit('LOGOUT');
	},
};

const getters = {
	isAuthenticated: (state) => state.isAuthenticated,
	user: (state) => state.user,
	storeId: (state) => state.storeId,
};

export default {
	namespaced: true, // 使用命名空间，避免命名冲突
	state,
	mutations,
	actions,
	getters,
};
